

import Contacts from "./components/Contact";
import Footer from "./components/Footer";
import MainHeader from "./components/MainHeader";
import Projects from "./components/Projects";



function App() {
  return (
    <>
      <MainHeader />
      <Projects />
      <Contacts />
      <Footer/>
    </>
  );
}

export default App;
